<template>
  <ul class="accordion">
    <slot />
  </ul>
</template>

<script>
export default {
  provide() {
    return { AccordionComponent: this.Accordion };
  },
  props: {},
  data() {
    return {
      Accordion: {
        count: 0,
        active: this.$route.hash ? this.$route.hash[1] : null,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  list-style: none;
  margin: 0;
  padding: 0;

  &__item:last-child {
    border-bottom: none;
  }
}
</style>
